import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHead: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHead"><Path d="M11 2C6.58172 2 3 5.58172 3 10C3 11.8604 3.63624 13.5749 4.70231 14.934C6.00986 16.6009 6.00618 18.1805 6.00073 20.5259C6.00037 20.6805 6 20.8385 6 21V22H15V19H19V14.0662L21.9138 12.3179L21.3321 11.4453C21.0215 10.9794 20.7314 10.5657 20.4598 10.1785C19.6556 9.0315 19.0143 8.11694 18.4868 6.76847C17.2219 3.5352 14.1621 2 11 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHead;
